import { AxiosResponse } from "axios";
import API from "../api";
import { Applications } from "../models/applications";

import BaseService from "./_base.service";

const endpoint = "applications";

const ApplicationsService = {
  ...BaseService<Applications>({ endpoint }),
};

export default ApplicationsService;
